import React from 'react';
import { Svg } from '../Svg/Svg';

interface MarkerProps {
  index: number;
  isActive?: boolean;
  onClick?: () => void;
  ariaLabel?: string;
  lat?: number; // Used by GoogleMapReact for positioning
  lng?: number; // Used by GoogleMapReact for positioning
}

const Marker: React.FC<MarkerProps> = ({ 
  index, 
  isActive = false, 
  onClick, 
  ariaLabel = '' 
}) => {
  return (
    <button className="reset mz-map-marker" onClick={onClick} aria-label={ariaLabel}>
      <Svg
        size={3}
        colour={isActive ? 'red' : 'grey'}
        type="pin"
      />
      <span className="text--white">{index}</span>
    </button>
  );
};

export default Marker;
